module.exports = __webpack_public_path__ + "img/symbol_2.2d5c6154.png";